import { z } from 'zod';
// ── Teacher subjects ──────────────────────────────────────────────────────
/**
 * A subject's grade level. `classTypeId` is the numeric AIMSIS class-type id and
 * is present only for a class type synced from AIMSIS; a CBT-native classroom
 * carries a grade level name and no numeric class type. The syllabus lookup
 * needs the numeric id, so callers omit the curriculum group when it is absent
 * rather than sending a fabricated id.
 */
export const TeacherGradeLevel = z.object({
    classTypeId: z.number().int().positive().optional(),
    classTypeName: z.string(),
});
/**
 * A subject option for the Teacher Question Bank.
 *
 * `subjectKey` is the stable option identity — it exists for every subject,
 * including a CBT-native one that has no numeric AIMSIS id. `subjectId` is the
 * numeric AIMSIS id used by the curriculum group and the syllabus lookup, and is
 * present only when the subject master carries one.
 */
export const TeacherSubject = z.object({
    subjectKey: z.string().min(1),
    subjectId: z.number().int().positive().optional(),
    subjectName: z.string(),
    gradeLevels: z.array(TeacherGradeLevel),
});
export const TeacherSubjectsResponse = z.object({
    subjects: z.array(TeacherSubject),
});
// ── Syllabus data ─────────────────────────────────────────────────────────
export const SyllabusCapaian = z.object({
    capaianId: z.number().int().positive(),
    capaianLabel: z.string(),
});
export const SyllabusTujuan = z.object({
    tujuanId: z.number().int().positive(),
    tujuanLabel: z.string(),
    capaianId: z.number().int().positive(),
});
export const SyllabusDataResponse = z.object({
    capaian: z.array(SyllabusCapaian),
    tujuan: z.array(SyllabusTujuan),
});
export const SyllabusQuery = z.object({
    subjectId: z.coerce.number().int().positive(),
    classTypeId: z.coerce.number().int().positive(),
    capaianId: z.coerce.number().int().positive().optional(),
}).strict();
//# sourceMappingURL=teacher-syllabus.js.map